export const API_URL =
  import.meta.env.VITE_API_URL ??
  (process.env.NODE_ENV === 'development' ? 'http://localhost:6050' : '/api');

export class HttpError extends Error {
  status: number;

  detail: string | null;

  constructor(status: number, detail: string | null) {
    super(`HTTP status ${status}${detail ? `: ${detail}` : ''}`);
    this.name = 'HttpError';
    this.status = status;
    this.detail = detail;
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}

export async function checkResponseForError(
  response: Response,
  throwNotFoundErrors = true
): Promise<void> {
  if (response.status < 200 || response.status > 299) {
    if (!throwNotFoundErrors && response.status === 404) {
      return;
    }
    let detail: string | null = null;
    try {
      detail = await response.text();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
    throw new HttpError(response.status, detail);
  }
}

export async function getResponseJSON<T = unknown>(
  response: Response,
  throwNotFoundErrors = true
): Promise<T> {
  await checkResponseForError(response, throwNotFoundErrors);
  return response.json() as Promise<T>;
}

export async function getResponseText<T = unknown>(
  response: Response
): Promise<T> {
  await checkResponseForError(response);
  return response.text() as Promise<T>;
}

export function fetchSameOrigin(
  route: string,
  options?: RequestInit
): Promise<Response> {
  const url = `${API_URL}${route}`;
  return fetch(url, {
    credentials: 'same-origin',
    ...options,
  });
}

export function fetchJSONSameOrigin(
  route: string,
  data?: Record<string | number, unknown> | Record<string | number, unknown>[],
  method = 'POST',
  options?: RequestInit
): Promise<Response> {
  return fetchSameOrigin(route, {
    ...options,
    method,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...options?.headers,
    },
    body: data ? JSON.stringify(data) : undefined,
  });
}
